import baseRequest from "../_core/baseRequest";

export default {
    sendResetMail: params => baseRequest.post("/send-reset-mail", params),
    getEmailAndHash: hash => baseRequest.get("/reset-password?hash=" + hash),
    resetPassword: params => baseRequest.post("/reset-password", params),
    changePassword: params => baseRequest.post("/changepassword", params),
    changePasswordWithToken: params => baseRequest.post("/changepasswordpublic", params)
};
